<template>
    <div :title="title" class="flex space-x-1 p-1 px-2 rounded hover:bg-slate-100 dark:hover:bg-slate-600">
        <div class="w-20">
            {{ format(label) }}
        </div>
        <div class="w-14 text-right">
            {{ format(value) }}
        </div>
        <div v-if="totalRate" class="w-20 text-right">
            <span :class="{'text-green-500' : totalRate > 0, 'text-red-500' : totalRate < 0}">
                <span v-if="totalRate > 0">+</span>{{ format(totalRate) }}
            </span>
        </div>
        <div v-if="rate" class="w-12 text-right">
            <span :class="{'text-green-500' : rate > 0, 'text-red-500' : rate < 0}">
                <span v-if="rate > 0">+</span>{{ format(rate) }}
            </span>
        </div>
    </div>
</template>
<script>
import NumberFormatter from "../../js/partials/NumberFormatter";

export default {
    props: [
        'label',
        'title',
        'value',
        'totalRate',
        'rate',
    ],
    methods: {
        format(nr) {
            return NumberFormatter.format(nr);
        },
    }
}
</script>